<template>
  <a-modal
    @ok="handleOk"
    @cancel="visible = false"
    :width="800"
    title="活动配置"
    ok-text="保存"
    :confirm-loading="loading"
    :visible="visible">
    <Config :robot-id="currentRobotId" ref="config"/>
  </a-modal>
</template>

<script>
import Config from '@/views/lucky/config'
export default {
  name: 'ConfigModal',
  components: { Config },
  data: () => ({
    visible: false,
    currentRobotId: null,
    loading: false
  }),
  methods: {
    show(currentRobotId) {
      this.loading = true
      this.currentRobotId = currentRobotId
      this.visible = true
      this.$nextTick().then(() => {
        this.$refs.config.getData().finally(() => {
          this.loading = false
        })
      })
    },
    handleOk() {
      this.loading = true
      this.$refs.config.submit().then(([err]) => {
        if (!err) {
          this.visible = false
          this.$message.success('保存成功')
        } else {
          this.$message.error(err)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
